import React from 'react';
import LandingNavbar from './LandingNavbar';
import HeroSectionLanding from './herosection/HeroSectionLanding';
import DashboardPreviewSection from './previewsection/DashboardPreviewSection';
import BenefitsSection from './benefitssection/LandingBenefitsSection';
import MembershipPlansSection from './membershipsection/MembershipPlansSection';
import InsightSection from './strategicsection/InsightSection';
import ContactSection from './ContactSection/ContactSection';



const LandingPage = () => {
  return (
    <div>
      <LandingNavbar />
      <HeroSectionLanding />
      <InsightSection />
      <DashboardPreviewSection />
      <BenefitsSection />
      <MembershipPlansSection />
      <ContactSection />
      {/* Aquí después podrás poner el buscador, la sección de membresías, etc. */}
    </div>
  );
};

export default LandingPage;

